var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/components/toast-manager.component.tsx
import React3, { Component } from "react";
import styled2 from "styled-components";
import { TransitionGroup, CSSTransition } from "react-transition-group";

// src/components/toast-message.component.tsx
import React2 from "react";
import styled from "styled-components";
import { useIntl, FormattedHTMLMessage } from "@leagueplatform/locales";
import {
  breakpoints,
  vars,
  Heading,
  Flex,
  Icon,
  ICONS,
  Box
} from "@leagueplatform/ui-kit";

// src/components/toast-message.constants.ts
var TOAST_STATUS = /* @__PURE__ */ ((TOAST_STATUS2) => {
  TOAST_STATUS2["SUCCESS"] = "success";
  TOAST_STATUS2["ERROR"] = "error";
  TOAST_STATUS2["WARNING"] = "warning";
  TOAST_STATUS2["NOTE"] = "note";
  TOAST_STATUS2["ATTENTION"] = "attention";
  TOAST_STATUS2["INFO"] = "info";
  TOAST_STATUS2["INVERTED"] = "inverted";
  return TOAST_STATUS2;
})(TOAST_STATUS || {});

// src/components/icons/icon.component.tsx
import React from "react";
import SuccessIcon from "./assets/success-icon.svg";
import ErrorIcon from "./assets/error-icon.svg";
import InfoIcon from "./assets/info-icon.svg";
import { Image } from "@leagueplatform/genesis-commons";
var ToastIcon = ({ iconType }) => {
  switch (iconType) {
    case "ERROR" /* ERROR */:
      return /* @__PURE__ */ React.createElement(Image, { src: ErrorIcon, alt: "" });
    case "INFO" /* INFO */:
      return /* @__PURE__ */ React.createElement(Image, { src: InfoIcon, alt: "" });
    case "SUCCESS" /* SUCCESS */:
      return /* @__PURE__ */ React.createElement(Image, { src: SuccessIcon, alt: "" });
    default:
      return null;
  }
};

// src/components/toast-message.component.tsx
import { FormattedMessage } from "react-intl";
var {
  greyLighter,
  greyLight,
  opal,
  red,
  lightGreen,
  lightRose,
  lightOrange,
  orange,
  lightYellow,
  darkYellow,
  purpleLightest,
  purpleLight,
  purpleDark,
  white,
  greyLightest,
  mediumGrey,
  black,
  blue,
  blueLightest,
  darkGrey
} = vars.colour;
var { WARNING, INFORMATION } = ICONS;
var getMessageStyle = (type) => {
  switch (type) {
    case "success" /* SUCCESS */:
      return {
        primary: opal,
        secondary: lightGreen,
        icon: "SUCCESS" /* SUCCESS */
      };
    case "error" /* ERROR */:
      return {
        primary: red,
        secondary: lightRose,
        icon: "ERROR" /* ERROR */
      };
    case "warning" /* WARNING */:
      return {
        primary: orange,
        secondary: lightOrange,
        icon: WARNING
      };
    case "note" /* NOTE */:
      return {
        primary: purpleLight,
        secondary: purpleLightest,
        icon: INFORMATION
      };
    case "attention" /* ATTENTION */:
      return {
        primary: darkYellow,
        secondary: lightYellow,
        icon: WARNING
      };
    case "info" /* INFO */:
      return {
        primary: blue,
        secondary: blueLightest,
        icon: "INFO" /* INFO */
      };
    case "inverted" /* INVERTED */:
      return {
        primary: white,
        secondary: purpleDark,
        icon: INFORMATION
      };
    default:
      return {
        primary: mediumGrey,
        secondary: greyLightest,
        icon: INFORMATION
      };
  }
};
var MessageWrapper = styled(Flex)`
  position: relative;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.09);
  border-radius: 4px;
  border: 1px solid ${greyLighter};
  align-items: center;
  width: 40rem;
  pointer-events: auto;
  cursor: pointer;
  border-left: 8px solid
    ${(props) => getMessageStyle(props.type).primary};
  background-color: ${(props) => getMessageStyle(props.type).secondary};
  color: ${(props) => props.type === "inverted" /* INVERTED */ ? getMessageStyle(props.type).primary : ""};
  margin-right: 5.5rem;
  @media ${breakpoints.belowLap} {
    margin: 0 auto;
  }
`;
var MessageIcon = styled(Flex)`
  background-color: ${(props) => getMessageStyle(props.type).primary};
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
  padding: 0.5rem;

  > svg path {
    fill: ${(props) => getMessageStyle(props.type).secondary};
  }
`;
var ToastMessageIcon = styled(Flex)`
  margin-right: 1.2rem;
  flex-shrink: 0;
`;
var MessageHeading = styled(Heading)`
  margin: 0;
  line-height: 2.2rem;
  text-align: left;
`;
var MessageCloseButtonWrapper = styled.button`
  position: absolute;
  top: ${(props) => props.content ? "1rem" : "50%"};
  transform: translateY(
    ${(props) => props.content ? "none" : "-50%"}
  );
  right: 0.5rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;

  > svg path {
    transition: all 0.3s ease;
  }

  &:hover,
  &:focus {
    > svg path {
      fill: ${(props) => props.type === "inverted" /* INVERTED */ ? greyLight : black};
    }
  }
`;
var MessageSubHead = styled.p`
  line-height: 2.2rem;
  font-size: 1.6rem;
`;
var renderIcon = (type) => {
  switch (type) {
    case "success" /* SUCCESS */:
    case "error" /* ERROR */:
    case "info" /* INFO */:
      return /* @__PURE__ */ React2.createElement(ToastMessageIcon, null, /* @__PURE__ */ React2.createElement(ToastIcon, { iconType: getMessageStyle(type).icon }));
    default:
      return /* @__PURE__ */ React2.createElement(MessageIcon, { type }, /* @__PURE__ */ React2.createElement(Icon, { icon: getMessageStyle(type).icon, size: "1.2rem" }));
  }
};
var ToastMessage = ({
  messageId,
  text,
  textId,
  type,
  values,
  content,
  contentId,
  dismiss,
  toastMessageMouseEntered,
  toastMessageMouseLeft
}) => {
  const { formatMessage } = useIntl();
  const flexProps = {
    justifyContent: "flex-end",
    mt: 1,
    onClick: () => dismiss(messageId),
    onMouseEnter: toastMessageMouseEntered,
    onMouseLeave: toastMessageMouseLeft
  };
  const messageWrapperProps = {
    type,
    p: 2
  };
  const boxProps = {
    pl: 2,
    pr: [0, 0, 3]
  };
  return /* @__PURE__ */ React2.createElement(Flex, __spreadValues({}, flexProps), /* @__PURE__ */ React2.createElement(MessageWrapper, __spreadValues({}, messageWrapperProps), renderIcon(type), /* @__PURE__ */ React2.createElement(Box, __spreadProps(__spreadValues({}, boxProps), { "aria-live": "polite" }), text || textId ? /* @__PURE__ */ React2.createElement(MessageHeading, { level: 5 }, textId ? /* @__PURE__ */ React2.createElement(FormattedMessage, { id: textId, values }) : text) : null, content || contentId ? /* @__PURE__ */ React2.createElement(MessageSubHead, null, contentId ? /* @__PURE__ */ React2.createElement(FormattedHTMLMessage, { id: contentId, values }) : content) : null), /* @__PURE__ */ React2.createElement(
    MessageCloseButtonWrapper,
    {
      type,
      onClick: () => dismiss(messageId),
      "aria-label": formatMessage({ id: "DISMISS_TOAST" }),
      content
    },
    /* @__PURE__ */ React2.createElement(
      Icon,
      {
        icon: ICONS.X,
        size: "2rem",
        colour: type === "inverted" /* INVERTED */ ? getMessageStyle(type).primary : darkGrey
      }
    )
  )));
};

// src/components/toast-manager.component.tsx
import { Flex as Flex2 } from "@leagueplatform/ui-kit";
import { v4 as uuidv4 } from "uuid";
var ANIMATION_DURATION_MILIS = 333;
var instance;
var ToastContainer = styled2(Flex2)`
  position: fixed;
  z-index: 1000;
  bottom: 0;
  right: 0;
  width: 100%;
  flex-direction: column;
  padding: 2.4rem;
  pointer-events: none;

  .transition-item-enter,
  .transition-item-exit-active,
  .transition-item-exit-done {
    transition-property: opacity, transform;
    transition-duration: ${ANIMATION_DURATION_MILIS}ms;
    transition-timing-function: linear, ease-in;
    opacity: 0;
    transform: translateY(100%);
  }

  .transition-item-enter-active,
  .transition-item-enter-done {
    transition-timing-function: linear, cubic-bezier(0.68, -0.55, 0.27, 1.55);

    opacity: 1;
    transform: translateY(0);
  }
`;
var registerToastManager = (ref) => {
  if (ref) {
    instance = ref;
    toastActions.add = ref.addToast;
    toastActions.remove = ref.removeToast;
    toastActions.removeAll = ref.removeAllToasts;
  }
};
var checkToastManagerInstance = () => {
  if (!instance)
    console.warn(
      "You are trying to call one of the ToastManager functions without initializing the ToastManager component first."
    );
};
var toastActions = {
  add: checkToastManagerInstance,
  remove: checkToastManagerInstance,
  removeAll: checkToastManagerInstance
};
var ToastManager = class extends Component {
  constructor(props) {
    super(props);
    this.messageTimeouts = [];
    this.addToast = (toast) => {
      toast.messageId = uuidv4();
      this.setState({ toasts: [...this.state.toasts, toast] });
      if (toast.shouldAutoClose == false ? toast.shouldAutoClose : true)
        this.setToastTimeout(toast);
    };
    this.removeToast = (removeToastId) => {
      this.setState({
        toasts: this.state.toasts.filter(
          (toast) => toast.messageId !== removeToastId
        )
      });
    };
    this.removeAllToasts = () => {
      this.setState({ toasts: [] });
    };
    this.setToastTimeout = (toast) => {
      const timeout = window.setTimeout(() => {
        this.removeToast(toast.messageId);
      }, 5e3);
      this.messageTimeouts.push(timeout);
    };
    this.removeAllToastsAfterTimeout = () => {
      const timeout = window.setTimeout(() => {
        this.removeAllToasts();
      }, 3e3);
      this.messageTimeouts.push(timeout);
    };
    this.clearTimeouts = () => {
      this.messageTimeouts.map((timeout) => clearTimeout(timeout));
      this.messageTimeouts = [];
    };
    this.state = { toasts: [] };
    registerToastManager(this);
  }
  render() {
    const { toasts } = this.state;
    return /* @__PURE__ */ React3.createElement(ToastContainer, { className: "toast-messages-container", "aria-live": "polite" }, /* @__PURE__ */ React3.createElement(TransitionGroup, null, toasts == null ? void 0 : toasts.map((toast) => {
      const props = __spreadProps(__spreadValues({}, toast), {
        dismiss: this.removeToast,
        toastMessageMouseEntered: this.clearTimeouts,
        toastMessageMouseLeft: this.removeAllToastsAfterTimeout
      });
      return /* @__PURE__ */ React3.createElement(
        CSSTransition,
        {
          timeout: ANIMATION_DURATION_MILIS,
          key: toast.messageId,
          classNames: "transition-item"
        },
        /* @__PURE__ */ React3.createElement(ToastMessage, __spreadValues({}, props))
      );
    })));
  }
};
export {
  TOAST_STATUS,
  ToastManager,
  toastActions
};
//# sourceMappingURL=index.js.map